import BusinessIcon from "@mui/icons-material/Business";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, CircularProgress, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { type Facility } from "@src/appV2/User/api/useSearchFacilities";
import { forwardRef } from "react";

interface FacilityResultItemProps {
  facility: Facility;
  selected: boolean;
  expanded: boolean;
  isLoadingShifts: boolean;
  onClick: () => void;
}

export const FacilityResultItem = forwardRef<HTMLDivElement, FacilityResultItemProps>(
  (props, ref) => {
    const { facility, selected, expanded, isLoadingShifts, onClick } = props;

    return (
      <ListItemButton
        ref={ref}
        selected={selected}
        sx={{
          py: 1,
          px: 2,
          "&.Mui-selected": {
            backgroundColor: "action.selected",
          },
        }}
        onClick={onClick}
      >
        <ListItemIcon sx={{ minWidth: 40 }}>
          <BusinessIcon color="secondary" />
        </ListItemIcon>
        <ListItemText
          primary={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Text sx={{ fontWeight: 500 }}>{facility.name}</Text>
              {selected &&
                (expanded ? (
                  <ExpandMoreIcon fontSize="small" />
                ) : (
                  <ChevronRightIcon fontSize="small" />
                ))}
              {isLoadingShifts && expanded && <CircularProgress size={14} />}
            </Box>
          }
          secondary={`${facility.type} • ${facility.status}`}
          secondaryTypographyProps={{ variant: "caption" }}
        />
      </ListItemButton>
    );
  }
);

FacilityResultItem.displayName = "FacilityResultItem";
